module.exports = __webpack_public_path__ + "media/images/thumbs_up-1c49ac66068f0f9317efd367c36ee350.png";